import { Navigate, Route, Routes } from "react-router-dom";
import { useAuthStore } from "./features/auth/store";
import LoginPage from "./pages/auth/LoginPage";
import { MainApp } from "./app/routes";
import { useEffect, useState } from "react";

function ToastHost() {
  const [toast, setToast] = useState(null);
  useEffect(() => { const onToast = (event) => { setToast(event.detail); window.setTimeout(() => setToast(null), 1500); }; window.addEventListener("tupi:toast", onToast); return () => window.removeEventListener("tupi:toast", onToast); }, []);
  return toast ? <div className={`global-toast ${toast.type}`}>{toast.message}</div> : null;
}

export default function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <><ToastHost /><Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/*" element={<MainApp />} />
    </Routes></>
  );
}
